import { PureComponent, ReactNode } from "react";
import RestApiResponseBodyPlacehlderSvg from "../../../../svgs/rest-api-response-body-placehlder.svg";
import { KuikaFormField } from "../../../ui-kit/kuika-form-page/kuika-form-page";
import { RestApiEndpointBodyEditor } from "./rest-api-endpoint-body-editor";

interface IRestApiEndpointBodyTabProps {
  isRequestBodyEditable: boolean;
  isResponseBodyEditable: boolean;
  showPlaceholderOnResponseBody: boolean;
  handleChangeResponseEditorStatus: (isEditable: boolean) => void;
}
interface IRestApiEndpointBodyTabState {}

export class RestApiEndpointBodyTab extends PureComponent<IRestApiEndpointBodyTabProps, IRestApiEndpointBodyTabState> {
  constructor(props) {
    super(props);
  }

  responseBodyPlaceholder = () => (
    <div className="kuika__data-diagram__create-con__container__rest-api-body-placeholder">
      <RestApiResponseBodyPlacehlderSvg className="kuika__data-diagram__create-con__container__rest-api-body-placeholder__img" />
      <div className="kuika__data-diagram__create-con__container__rest-api-body-placeholder__text">
        Click Run to get a response
      </div>
    </div>
  );

  render(): ReactNode {
    const {
      isRequestBodyEditable,
      isResponseBodyEditable,
      showPlaceholderOnResponseBody,
      handleChangeResponseEditorStatus
    } = this.props;
    return (
      <>
        <KuikaFormField name="requestBody" className="kuika-form-section__wide">
          <RestApiEndpointBodyEditor label="Request Body" isEditable={isRequestBodyEditable} />
        </KuikaFormField>

        <KuikaFormField name="responseBody" className="kuika-form-section__wide">
          <RestApiEndpointBodyEditor
            label="Response Body"
            showSwitch
            isEditable={isResponseBodyEditable}
            onEditModeChange={(value) => {
              handleChangeResponseEditorStatus(value);
            }}
            placeholder={showPlaceholderOnResponseBody ? this.responseBodyPlaceholder() : undefined}
          />
        </KuikaFormField>
      </>
    );
  }
}
